<ng-container>
  <app-game-category-short [data]="categories | slice : 0  : 3"></app-game-category-short>
  <app-game-operator-short *ngIf="operators" [operators]="operators"></app-game-operator-short>
  <app-game-category-short [data]="categories | slice : 3"></app-game-category-short>
  <app-front-expansion-panel *ngIf="expansionPanel" [data]="expansionPanel" [isOpenFirst]="true"></app-front-expansion-panel>
</ng-container>

